<template>
    <div class="wrap white-bg mb40">
            <div class="apply-title">校园合作&商务合作</div>
            <div class="campus-cooperate el-row-overflow">
                <el-row :gutter="40"  justify="center">
                    <el-col :md="9" :sm="12" :xs="24">
                        <p class="cooperate-descript">文都教育在校园有着丰富的市场资源。在校园路演、讲座、广告位、校园渠道资源有着多年的运营经验。丰富的校园资源也为文都教育带来了庞大的用户群体。同时文都教育在校园合作方面也希望容纳百家之长，求同存异，共同打造校园教育平台综合体。在校园活动，资源共享方面期待共赢企业，同时诚招文都教育全国高校校园大使。</p>
                    </el-col>
                    <el-col :md="11" :sm="12" :xs="24">
                        <div class="cooperate-concat">
                            <p>电话：156 0012 8367</p>
                            <p>邮箱：676791336@qq.com</p>
                            <p>网址：<a href="https://www.wendu.com" target="_blank">www.wendu.com</a></p>
                            <p>地址：北京市海淀区中关村南大街17号韦伯时代中心C座北配楼文都集团</p>
                            <p>联系人：杜老师</p>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
</template>

<script>
import { defineComponent,ref } from 'vue'
export default defineComponent({
 setup(){
     
     return{
        
     }
 }
})
</script>

<style lang="scss" scoped type="text/scss">
.wrap{
    overflow: hidden;
}
.campus-cooperate{
    padding:40px;
    font-size:14px;
    color:#1B1D1F;
    line-height: 24px;
    overflow: hidden;
    .cooperate-descript{
        margin-bottom:16px;
    }
    .cooperate-concat{
        p{
            margin-bottom:8px;
            overflow: hidden;
        }
    }
    a{
        color:#1B1D1F; 
    }
}
</style>
